import { ChangeDetectionStrategy, Component } from '@angular/core'
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router'
import { Subject } from 'rxjs'
import { filter, map, switchMap, takeUntil } from 'rxjs/operators'
import { LeadSection, LeadSections, LeadSection_ } from '@appShared/services/lookup/lead-section'

@Component({
    selector: 'app-content-shell',
    templateUrl: './content-shell.component.html',
    styleUrls: ['./content-shell.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterOutlet]
})
export class ContentShellComponent {
   private _ngDestroyed$ = new Subject();
   private _initialLeadSection = LeadSections.find(section => section.code === LeadSection_.Home);
   leadSection = { ...this._initialLeadSection };

   constructor(
      router: Router,
      activatedRoute: ActivatedRoute
   ) {

      router.events
         .pipe(
            takeUntil(this._ngDestroyed$),
            filter(routeEvent => routeEvent instanceof NavigationEnd),
            map(() => activatedRoute),
            map(route => {
               while (route.firstChild) route = route.firstChild
               return route
            }),
            switchMap(firstChild => {
               return firstChild?.data
            }),
            map((data: LeadSection) => {
               return data
            })
         )
         .subscribe(data => {
            this.leadSection = { ...(data['section'] || this._initialLeadSection as LeadSection) }

         })

      //breadcrumbService.breadCrumbData.subscribe(breadcrumbs => {
      //   console.log('from member-shell')
      //   console.table(breadcrumbs);
      // })
   }

   ngOnDestroy(): void {
      this._ngDestroyed$.next(true)
      this._ngDestroyed$.complete()
   }
}
